import { render, staticRenderFns } from "./UserInformation.vue?vue&type=template&id=545ed834&scoped=true"
import script from "./UserInformation.vue?vue&type=script&lang=js"
export * from "./UserInformation.vue?vue&type=script&lang=js"
import style0 from "./UserInformation.vue?vue&type=style&index=0&id=545ed834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ed834",
  null
  
)

export default component.exports